import React, { useState, useContext } from "react";
import AuthContext from "../context/AuthContext";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { requestPasswordReset } from "../api/UserAPI";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useContext(AuthContext);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotSuccess, setForgotSuccess] = useState(false);
  const [forgotError, setForgotError] = useState("");

  if (user) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      console.error("Failed to login", err);
      alert("Login failed");
    }
  };

  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    setForgotLoading(true);
    setForgotError("");
    try {
      await requestPasswordReset(forgotEmail);
      setForgotSuccess(true);
    } catch (err) {
      setForgotError("Something went wrong. Please try again.");
    } finally {
      setForgotLoading(false);
    }
  };

  const handleBackToLogin = () => {
    setShowForgot(false);
    setForgotEmail("");
    setForgotSuccess(false);
    setForgotError("");
  };

  return (
    <div className="flex flex-col lg:flex-row w-screen">
      <div className="flex items-center justify-center border-blue-500 lg:h-screen lg:border-r lg:w-3/5">
        <div className="flex items-center justify-center lg:h-screen">
          <img
            src={`${process.env.PUBLIC_URL}/blorp_logo.png`}
            alt="[Tink Art]"
            className="w-48 h-48 object-contain lg:w-72 lg:h-72"
          />
        </div>
      </div>
      <div className="flex flex-col max-w-md my-auto mx-auto lg:w-2/5">
        {!showForgot ? (
          <form onSubmit={handleSubmit} className="p-4 max-w-md mx-auto">
            <h1 className="text-xl font-bold mb-4">Login</h1>
            <input
              type="text"
              placeholder="Email or Username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mb-2 p-2 border rounded"
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mb-2 p-2 border rounded"
            />
            <button className="bg-blue-500 text-white w-full px-4 py-2 mb-2 rounded hover:bg-black hover:text-white">
              Log In
            </button>
            <Link to="/signup">
              <button className="border border-black w-full px-4 py-2 rounded hover:bg-black hover:text-white">
                Sign Up
              </button>
            </Link>
            <div className="text-center mt-3">
              <button
                type="button"
                onClick={() => setShowForgot(true)}
                className="text-sm text-blue-500 hover:underline"
              >
                Forgot password?
              </button>
            </div>
          </form>
        ) : (
          <div className="p-4 max-w-md mx-auto w-full">
            <h1 className="text-xl font-bold mb-4">Reset Password</h1>
            {forgotSuccess ? (
              <div>
                <p className="text-sm text-gray-700 mb-4">
                  If an account exists for that email, we sent a password reset link. Check your inbox.
                </p>
                <button
                  onClick={handleBackToLogin}
                  className="text-sm text-blue-500 hover:underline"
                >
                  Back to login
                </button>
              </div>
            ) : (
              <form onSubmit={handleForgotSubmit}>
                <p className="text-sm text-gray-600 mb-3">
                  Enter your email address and we'll send you a link to reset your password.
                </p>
                <input
                  type="email"
                  placeholder="Email address"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  required
                  className="w-full mb-2 p-2 border rounded"
                />
                {forgotError && (
                  <p className="text-sm text-red-500 mb-2">{forgotError}</p>
                )}
                <button
                  type="submit"
                  disabled={forgotLoading}
                  className="bg-blue-500 text-white w-full px-4 py-2 mb-2 rounded hover:bg-black hover:text-white disabled:opacity-50"
                >
                  {forgotLoading ? "Sending..." : "Send Reset Link"}
                </button>
                <button
                  type="button"
                  onClick={handleBackToLogin}
                  className="text-sm text-blue-500 hover:underline w-full text-center"
                >
                  Back to login
                </button>
              </form>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
